import { render, staticRenderFns } from "./FlexibleContentArea.vue?vue&type=template&id=97b2a4f2&scoped=true&"
import script from "./FlexibleContentArea.vue?vue&type=script&lang=ts&"
export * from "./FlexibleContentArea.vue?vue&type=script&lang=ts&"
import style0 from "./FlexibleContentArea.vue?vue&type=style&index=0&id=97b2a4f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b2a4f2",
  null
  
)

export default component.exports